import { generateGroupedDateLabels } from '../helpers';

const dateLabels = generateGroupedDateLabels();

const values = [50, 397, 429, 366, 438];

export const aiConversationsDummyData = {
  data: dateLabels.map((name, idx) => ({
    name,
    values: [{ key: 'totalAiThreads', value: String(values[idx]) }],
  })),
  aggregates: {
    staffAnswered: '0',
    staffUnanswered: '0',
    followupTasksScheduling: '0',
    followupTasksOthers: '0',
    perIncreaseStaffAnswered: 0,
    perIncreaseStaffUnanswered: 0,
    perIncreaseTotalStaffTransfers: 0,
    staffTransfers: '0',
    totalAiThreads: '1680',
  },
};
